import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ committeeId = '', ...params }) => {
  return await dponetAPI.get(`/committees/${committeeId}`, { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/committees', data)
}

const changeStatus = async ({ committeeId = '' }) => {
  return await dponetAPI.put(`/committees/${committeeId}/change_status`)
}

const availableUsers = async ({ committeeId = '' }) => {
  return await dponetAPI.get(`/committees/${committeeId}/available_users`)
}

const destroy = async ({ committeeId = '' }) => {
  return await dponetAPI.delete(`/committees/${committeeId}`)
}

export default {
  get,
  create,
  changeStatus,
  availableUsers,
  destroy,
}
